import { Message } from 'components/message'

export class NewsletterObserver {
    constructor() {

    }

    next(res) {
        new Message('E-mail cadastrado com sucesso!', false)
    }

    error(error) {
        new Message("Não foi possível enviar sua solicitação")
    }

    complete() {}
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/newsletter/newsletter.observer.js